import { Routes } from '@angular/router'
import { LayoutBetaComponent } from '../layout/layout-beta/layout-beta.component'
import { AccountComponent } from '../organism/account/account.component'
import { AchievementsComponent } from '../organism/achievements/achievements.component'
import { ChangePhoneComponent } from '../organism/change-phone/change-phone.component'
import { CheckoutComponent } from '../organism/checkout/checkout.component'
import { DashboardComponent } from '../organism/dashboard/dashboard.component'
import { DesignSystemComponent } from '../organism/design-system/design-system.component'
import { HomeComponent } from '../organism/home/home.component'
import { KeysComponent } from '../organism/keys/keys.component'
import { LoginComponent } from '../organism/login/login.component'
import { NotFoundAlphaComponent } from '../organism/not-found-alpha/not-found-alpha.component'
import { PaymentComponent } from '../organism/payment/payment.component'
import { PaymentCompleteComponent } from '../organism/payment-complete/payment-complete.component'
import { ProductDetailsComponent } from '../organism/product-details/product-details.component'
import { RegisterCompleteComponent } from '../organism/register-complete/register-complete.component'
import { RegisterComponent } from '../organism/register/register.component'
import { SettingsComponent } from '../organism/settings/settings.component'
import { VerifyComponent } from '../organism/verify/verify.component'
import { OnboardingGuard } from '../guards/onboarding.guard'
import { EmailVerifyComponent } from '../organism/email-verify/email-verify.component'
import { LayoutAlphaComponent } from '../layout/layout-alpha/layout-alpha.component'
import { SidebarComponent } from '../molecule/sidebar/sidebar.component'

export const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'home',
  //   pathMatch: 'full',
  // },
  {
    path: '',
    component: LayoutAlphaComponent,
    // canActivate: [OnboardingGuard],
    children: [{
      path: '',
      component: HomeComponent
    },
    {
      path: 'category/:id',
      component: SidebarComponent,
    }]
  },
  {
    path: '',
    component: LayoutBetaComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'register',
        component: RegisterComponent,
      },
      {
        path: 'register-complete',
        component: RegisterCompleteComponent,
      },
      {
        path: 'verify',
        component: VerifyComponent,
      },
      {
        path: 'email-verify',
        component: EmailVerifyComponent,
      },
      {
        path: 'change-phone',
        component: ChangePhoneComponent,
      },
      {
        path: 'checkout',
        canActivate: [OnboardingGuard],
        component: CheckoutComponent,
      },
      {
        path: 'product-details/:slug',
        component: ProductDetailsComponent,
      },
      {
        path: 'payment',
        canActivate: [OnboardingGuard],
        component: PaymentComponent,
      },
      {
        path: 'payment-complete',
        component: PaymentCompleteComponent,
      },
      {
        path: 'account',
        component: AccountComponent,
        canActivate: [OnboardingGuard],
        children: [
          {
            path: '',
            redirectTo: 'settings',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            component: DashboardComponent,
          },
          {
            path: 'achievements',
            component: AchievementsComponent,
          },
          {
            path: 'keys',
            component: KeysComponent,
          },
          {
            path: 'settings',
            component: SettingsComponent,
          },
        ],
      },
    ],

  },

  { path: 'not-found', component: NotFoundAlphaComponent },
  { path: 'design-system', component: DesignSystemComponent },
]
